import React, { useState, useEffect } from "react";
import { Form, Radio } from "antd";
import Typing from "../Typing/Typing";
import * as Utils from "../../services/utils";
import CmpsAnimation from "../CmpsAnimation/CmpsAnimation";
import Timestamp from "../../components/Timestamp/Timestamp";
import CmpsMsgStatus from "../CmpsMsgStatus/CmpsMsgStatus";

function CmpsConsentThird({ onComplete, onScroll, form, onShowInput }) {
    const [typing, setTyping] = useState(true);
    const [msg, setMsg] = useState(false);
    const [msgChoose, setMsgChoose] = useState(true);

    let list = [
        { label: "Acconsento", value: true },
        { label: "Non acconsento", value: false },
    ];

    const onChange = (e) => {
        setMsg(form.getFieldValue("terzo_consenso").label);
        setMsgChoose(false);
        onComplete("step15");
    };

    useEffect(() => {
        Utils.eventsDataLayer("customPageview", "/chatbot-fissa-appuntamento/privacy-step-3");
        onShowInput(false);
        const timer = setTimeout(() => {
            setTyping(false);
            onScroll();
        }, 2200);
        return () => clearTimeout(timer);
    }, []);

    return (
        <section id="cmps-consent3">
            {typing && <Typing wait={1200} />}
            {!typing && (
                <div className="messages messages--receiver">
                    <div className="message">
                        <CmpsAnimation wait={300} last={!msgChoose}>
                            <span className="bubble">
                                {/* Dichiarando di aver scaricato e letto
              le INFORMATIVE, 
              che i miei dati
              personali siano comunicati a e trattati
              da Società terze per la finalità 
              indicata alla lettera c) per prodotti
              o servizi da queste ultime offerti. 
              Tale consenso comprende altresì il 
              consenso al trattamento dei propri 
              dati personali mediante l'utilizzo 
              di strumenti, anche informativi, 
              per verificare la coerenza dei prodotti 
              offerti, se ed entro gli stretti 
              limiti in cui ciò è prescritto dalle 
              disposizioni di vigilanza. */}
                                <b>Consenso al trattamento dei dati per la comunicazione a società terze dei dati per le relative attività commerciali e promozionali (lettera c)</b>
                                <br />
                                <br />
                                Preso atto dell'Informativa resa da Compass Banca S.p.A. ai sensi degli artt. 13 e 14 del Regolamento e della normativa nazionale vigente in materia di protezione dei
                                dati personali e del Codice di condotta per i sistemi informativi gestiti da soggetti privati in tema di crediti al consumo, affidabilità e puntualità nei pagamenti,
                                che i tuoi dati personali siano comunicati a e trattati da Società terze per la finalità indicata alla lettera c) per prodotti o servizi da queste ultime offerti. Tale
                                consenso comprende altresì il consenso al trattamento dei propri dati personali mediante l'utilizzo di strumenti, anche informatici, per verificare la coerenza dei
                                prodotti offerti, se ed entro gli stretti limiti in cui ciò è prescritto dalle disposizioni di vigilanza.
                            </span>
                        </CmpsAnimation>
                        {msgChoose && (
                            <CmpsAnimation wait={600} last={true}>
                                <span className="bubble">Seleziona la tua scelta</span>
                            </CmpsAnimation>
                        )}
                        <CmpsAnimation wait={900}>
                            {!msg && (
                                <Form.Item className={`cmps_radio_button cmps_radio_button__consent`} name="terzo_consenso">
                                    <Radio.Group onChange={onChange}>
                                        {list.map((item, index) => (
                                            <Radio.Button key={index} value={item}>
                                                {item.label}
                                            </Radio.Button>
                                        ))}
                                    </Radio.Group>
                                </Form.Item>
                            )}
                            <div className="info">
                                <span className="time">
                                    <Timestamp />
                                </span>
                            </div>
                        </CmpsAnimation>
                    </div>
                </div>
            )}
            {msg && (
                <div className="messages messages--sender">
                    <CmpsAnimation wait={300}>
                        <div className="message">
                            <span className="bubble">{msg}</span>
                        </div>
                        <div className="info">
                            <span className="time">
                                <Timestamp />
                            </span>
                            <CmpsMsgStatus />
                        </div>
                    </CmpsAnimation>
                </div>
            )}
        </section>
    );
}

export default CmpsConsentThird;
